import type { Contact } from "@core/schema/Contact.js";

export const contactActionTypes = ["email", "phone", "linkedinUrl"] as const satisfies (keyof Contact)[];
export type ContactActionType = (typeof contactActionTypes)[number];
